// Generated by purs version 0.13.0
"use strict";
var wheel = "wheel";
module.exports = {
    wheel: wheel
};
